(function (root) {
  'use strict';
  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  function resolveHelpKey(composition, axis, nativeMetal) {
    const metals = { '14k gold vermeil': 'vermeil', 'gold vermeil': 'vermeil', 'sterling silver': 'silver', '925 sterling silver': 'silver' };
    if (axis === 'metal' && nativeMetal !== undefined) return metals[normalize(nativeMetal)] || null;
    const parts = String(composition || '').split(/\s+&\s+/);
    if (parts.length !== 2) return null;
    const gems = { 'lab-grown sapphire': 'sapphire', 'lab grown sapphire': 'sapphire', 'lab-grown spinel': 'spinel', 'lab grown spinel': 'spinel', 'moissanite': 'moissanite', 'lab-grown moissanite': 'moissanite', 'yag': 'yag', 'lab-grown yag': 'yag', 'lab grown yag': 'yag' };
    if (axis === 'metal') return metals[normalize(parts[0])] || null;
    if (axis === 'gemstone') return gems[normalize(parts[1])] || null;
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { resolveHelpKey };
  if (!root.customElements || root.customElements.get('alvaura-selector-help')) return;
  class AlvauraSelectorHelp extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.trigger = this.querySelector('button');
      this.dialog = this.querySelector('dialog');
      this.info = this.closest('product-info');
      this.nativeFieldset = this.closest('variant-selects[data-context="main"]') ? this.closest('fieldset') : null;
      if (!this.trigger || !this.dialog || !this.info || !this.dialog.showModal) return;
      this.refresh = () => {
        const availability = this.info.querySelector('alvaura-availability');
        const composition = this.info.querySelector('[data-alvaura-composition]');
        const ready = availability?.hasAttribute('data-ready') && !['pending', 'unavailable'].includes(availability.dataset.state);
        const nativeMetal = this.dataset.axis === 'metal' && this.nativeFieldset
          ? this.nativeFieldset.querySelector('input[type="radio"]:checked')?.value || '' : undefined;
        const key = ready ? resolveHelpKey(composition?.textContent, this.dataset.axis, nativeMetal) : null;
        const template = key && this.querySelector(`template[data-help-key="${key}"]`);
        this.hidden = !template;
        if (!template) { if (this.dialog.open) this.dialog.close(); return false; }
        const title = template.dataset.helpTitle;
        this.querySelector('[data-help-heading]').textContent = title;
        this.querySelector('[data-help-body]').textContent = template.content.textContent;
        this.dialog.setAttribute('aria-label', title);
        this.trigger.setAttribute('aria-label', title);
        return true;
      };
      this.openHelp = (event) => { event.preventDefault(); event.stopPropagation(); if (this.refresh()) this.dialog.showModal(); };
      this.closeHelp = () => this.dialog.close();
      this.restoreFocus = () => { if (!this.hidden) this.trigger.focus(); };
      this.backdrop = (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeHelp();
      };
      this.trigger.addEventListener('click', this.openHelp);
      this.querySelector('.alvaura-selector-help__close').addEventListener('click', this.closeHelp);
      this.dialog.addEventListener('close', this.restoreFocus);
      this.dialog.addEventListener('click', this.backdrop);
      this.nativeChange = () => queueMicrotask(() => { if (this.isConnected) this.refresh(); });
      this.nativeFieldset?.addEventListener('change', this.nativeChange);
      this.observer = new MutationObserver(() => this.refresh());
      const composition = this.info.querySelector('[data-alvaura-composition]');
      const availability = this.info.querySelector('alvaura-availability');
      if (composition) this.observer.observe(composition, { childList: true, characterData: true, subtree: true });
      if (availability) this.observer.observe(availability, { attributes: true, attributeFilter: ['data-ready', 'data-state'] });
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.trigger?.removeEventListener('click', this.openHelp);
      this.querySelector('.alvaura-selector-help__close')?.removeEventListener('click', this.closeHelp);
      this.dialog?.removeEventListener('close', this.restoreFocus);
      this.dialog?.removeEventListener('click', this.backdrop);
      this.nativeFieldset?.removeEventListener('change', this.nativeChange);
      if (this.dialog?.open) this.dialog.close();
    }
  }
  root.customElements.define('alvaura-selector-help', AlvauraSelectorHelp);
})(typeof window === 'undefined' ? globalThis : window);
